import { AppThunk } from '../states/generateStore';
import { suiteCrmUrl, getBatteryProduct, getSubsidy, getPricingOptionName, getProductInfoByPartNumber } from './constants';

import shellSlice from '../states/shell/slice';
import snackBarSlice from '../states/snackbar/slice';
import { isTemplateExpression } from 'typescript';

export const productSandenPartNumber = [
  {key: 'sanden_315fqv', value: 'GAUS-315FQV'},
  {key: 'sanden_315fqs', value: 'GAUS-315FQS'},
  {key: 'sanden_300fqs', value: 'GAUS-300FQS'},
  {key: 'sanden_250fqs', value: 'GAUS-250FQS'},
  {key: 'sanden_160fqs', value: 'GAUS-160FQS'},
];
// const productExtraPartNumber = [
//   {key: 'Sanden_Complex_Install', value: 'Sanden_Complex_Install'},
//   {key: 'SANDEN_ELEC_EXTRA', value: 'SANDEN_ELEC_EXTRA'},
//   {key: 'RCBO', value: 'RCBO'},
//   {key: 'SwitchUpgrade', value: 'SwitchUpgrade'},
//   {key: 'HWS_R', value: 'HWS_R'},
//   {key: 'Sanden_Tank_Slab', value: 'Sanden_Tank_Slab'},
//   {key: 'Sanden_HP_Pavers', value: 'Sanden_HP_Pavers'},
//   {key: 'Site_Delivery', value: 'Site_Delivery'},
//   {key: 'Spec_Trade_Disc', value: 'Spec_Trade_Disc'},
//   {key: 'san_wall_bracket', value: 'san_wall_bracket'},
//   {key: 'Travel', value: 'Travel'},
//   {key: 'bca_building_class_2', value: 'bca_building_class_2'},
//   {key: 'bca_building_class_1', value: 'bca_building_class_1'},
//   {key: 'bca_building_class_3', value: 'bca_building_class_3'},
// ];
// const productCalculatingPartNumber = [
//   {key: 'STC Rebate Certificate', value: 'STC Rebate Certificate'},
//   {key: 'VEEC Rebate Certificate', value: 'VEEC Rebate Certificate'},
//   {key: 'PB', value: 'PB'},
//   {key: 'Sanden_Plb_Install_Std', value: 'Sanden_Plb_Install_Std'},
//   {key: 'Sanden_Elec_Install_Std', value: 'Sanden_Elec_Install_Std'},
//   {key: 'PizzaBase', value: 'PizzaBase'},
//   {key: 'SSI', value: 'SSI'},
//   {key: 'SANDEN_SUPPLY_ONLY', value: 'SANDEN_SUPPLY_ONLY'},
//   {key: 'QIK15−HPUMP', value: 'QIK15−HPUMP'},
//   {key: 'QIK20−HPUMP', value: 'QIK20−HPUMP'},
//   {key: 'SV_SHWR', value: 'SV_SHWR'},
//   {key: 'SA_REPS_Cl1_Reti_Gas_Conn', value: 'SA_REPS_Cl1_Reti_Gas_Conn'},
//   {key: 'SA_REPS_Cl1_No_Gas_Cl2', value: 'SA_REPS_Cl1_No_Gas_Cl2'},
//   {key: 'SA_REES', value: 'SA_REES'},
//   {key: 'SSPI', value: 'SSPI'},
// ];

const onLoadProductData = (): AppThunk =>
async (dispatch, getStore) => {
  try {

    let Freight_Battery_Storage = undefined;
    let resp = await fetch(suiteCrmUrl.concat(getProductInfoByPartNumber.concat("Freight_Battery_Storage")),
      { 
        method: 'GET',
      }
    );
    let res = await resp.json();
    if (res) {
      Freight_Battery_Storage = res;
    }

    let T_B_L_K = undefined;
    let respTBLK = await fetch(suiteCrmUrl.concat(getProductInfoByPartNumber.concat("T_B_L_K")),
      { 
        method: 'GET',
      }
    );
    let resTBLK = await respTBLK.json();
    if (resTBLK) {
      T_B_L_K = resTBLK;
    }

    let response_pricing = await fetch(suiteCrmUrl.concat(getPricingOptionName),
      { 
        method: 'GET',
      }
    );
    let result_pricing = await response_pricing.json();
    if (result_pricing) {
      dispatch(shellSlice.actions.updatePricingOptionNames(result_pricing.map((item: any) => {
        return {
          label: item.name,
          value: item.id
        }
      })));
    } else {
      // show warning
      dispatch(snackBarSlice.actions.updateAlert({message: "Can not get pricing option data from Server", severity: "warning"}));
      dispatch(snackBarSlice.actions.updateSnackBar(true));
    }
    // Get subsidy product
    let response = await fetch(suiteCrmUrl.concat(getSubsidy),
      {
        method: 'GET',
      }
    );
    let result = await response.json();
    if (result) {
      dispatch(shellSlice.actions.updateSubsidies(stcFirst(result)));
    } else {
      // show warning
      dispatch(snackBarSlice.actions.updateAlert({message: "Can not get subsidies product data from Server", severity: "warning"}));
      dispatch(snackBarSlice.actions.updateSnackBar(true));
    }

    let responsePrd = await fetch(suiteCrmUrl.concat(getBatteryProduct),
      { 
        method: 'POST',
      }
    );
    let resultPrd = await responsePrd.json();
    if (resultPrd) {
      // Update isLoaded
      dispatch(shellSlice.actions.updateIsLoaded(true));
      // Complete
      if (resultPrd.battery_main) dispatch(shellSlice.actions.updateProductBattery(resultPrd.battery_main));
      // Extra
      if (resultPrd.battery_extras) dispatch(shellSlice.actions.updateProductExtra(resultPrd.battery_extras));
      // Accessories
      if (resultPrd.battery_accessories) dispatch(shellSlice.actions.updateProductAccessories(resultPrd.battery_accessories));
      // Rebate
      const tmps = resultPrd.battery_rebate.map((item: any) => { return {...item, partNumber: item.part_number}});
      console.log(tmps);
      if (resultPrd.battery_rebate) dispatch(shellSlice.actions.updateSubsidies(resultPrd.battery_rebate.map((item: any) => { return {...item, partNumber: item.part_number}})));
      // Installs
      let tmp = resultPrd.battery_install;
      console.log(Freight_Battery_Storage);
      if (resultPrd.battery_install) dispatch(shellSlice.actions.updateProductInstalls(
        [
          ...resultPrd.battery_install,
          Freight_Battery_Storage,
          T_B_L_K,
        ]
      ));
    } else {
      // show warning
      dispatch(snackBarSlice.actions.updateAlert({message: "Can not get product data from Server", severity: "warning"}));
      dispatch(snackBarSlice.actions.updateSnackBar(true));
    }
  } catch (err) {
    console.log(err);
    // show error
    dispatch(snackBarSlice.actions.updateAlert({message: "onLoadProductData: Can not get data from Server", severity: "error"}));
    dispatch(snackBarSlice.actions.updateSnackBar(true));
  }
}

const stcFirst = (arr: any) => {
  const stc = "STC Rebate Certificate";
  let nameArr = arr.map((item: any) => {
    return item.partNumber;
  });

  let index = nameArr.indexOf(stc);
  nameArr.splice(0, 0, stc);
  nameArr.splice(index + 1, 1);
  
  return nameArr.map((item: any) => {
    return arr.filter((sub: any) => sub.partNumber === item)[0];
  });
}

export default onLoadProductData;